import { typecastRouteProps } from "shared/helpers/routing";

export default [
  {
    component: () => import("pages/PodcastEpisodesPage.vue"),
    meta: {
      title: "Podcast Episodes",
    },
    name: "podcast_episodes",
    path: "/podcast_episodes",
    props: (route) => typecastRouteProps(route),
  },
  {
    component: () => import("pages/PodcastEpisodeEdit.vue"),
    meta: {
      title: "Edit Podcast Episode",
    },
    name: "podcast_episodes-edit",
    path: "/podcast_episodes/:id/edit",
    props: true,
  },
  {
    component: () => import("pages/PodcastEpisodeEdit.vue"),
    meta: {
      title: "Create Podcast Episode",
    },
    name: "podcast_episodes-new",
    path: "/podcast_episodes/new",
  },
];
